import React, { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ACCESS_TOKEN } from "../../constants"
import { Link, useHistory } from "react-router-dom";
import Input from "../../components/input";
import CircularProgress from '@mui/material/CircularProgress';

import { Button, Checkbox } from '@mui/material';
import { setCredentials } from '../../features/auth/authSlice';
import { useDispatch } from 'react-redux';
import {useLoginMutation, useLoginGoogleUserMutation} from "../../services/accountsApi";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'var(--light-yellow)',
  p: "2em",
  borderRadius: '2em',
  width: '100%',
  maxWidth: '365px',
  boxSizing: 'border-box',
};

const WarningIcon = () => {
  return (
    <svg style={{ margin: '0 0.5em 0 0 ' }} width="34" height="35" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.906 4.5C12.93 4.5 4 13.472 4 24.5C4 35.528 12.972 44.5 24 44.5C35.028 44.5 44 35.528 44 24.5C44 13.472 34.986 4.5 23.906 4.5ZM24 40.5C15.178 40.5 8 33.322 8 24.5C8 15.678 15.134 8.5 23.906 8.5C32.782 8.5 40 15.678 40 24.5C40 33.322 32.822 40.5 24 40.5Z" fill="#FF0000" />
      <path d="M22 14.5H26V28.5H22V14.5ZM22 30.5H26V34.5H22V30.5Z" fill="#FF0000" />
    </svg>
  )
}

const SignInButton = () => {
  return (
    <Button
      type="submit"
      variant="contained"
      sx={{ width: '100%', fontSize: '1.25rem' }}
    >
      Sign In
    </Button>
  )
}


export default function Login({ show, handleClose, handleShow }) {
  const [initLogin, {isLoading: loginIsLoading}] = useLoginMutation();
  const [initLoginGoogleUser, {isLoading: loginGoogleUserIsLoading}] = useLoginGoogleUserMutation();

  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState({
    value: "",
    error: null,
  });
  const [password, setPassword] = useState({
    value: "",
    error: null,
  });

  const dispatch = useDispatch();

  let history = useHistory();

  const responseGoogle = (response) => {
    if (response.error) {
      console.log(response);
      return;
    }
    initLoginGoogleUser(response)
      .unwrap()
      .then((res) => {
        localStorage.setItem(ACCESS_TOKEN, response.token);
        handleLogin();
      })
      .catch((err) => console.log(err.message));
  };

  const handleLogin = () => {
    handleClose();
    history.push("/dashboard/jobs");
  };

  const submit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    initLogin({ email: email.value, password: password.value })
      .unwrap()
      .then((response) => {
        dispatch(setCredentials({accessToken: response.jwtToken, user: response}))
        localStorage.setItem(ACCESS_TOKEN, response.jwtToken);
        handleLogin();
      })
      .catch(async (error) => {
        setIsLoading(false);
        if (error.status == 400) {
          setErrorMessage(error?.data?.message || "Email or password is incorrect");
        }
      });
      
  };

  const handleCloseAndResetError = () => {
    setErrorMessage(null);
    handleClose();
  };
  
  return (

    <Modal
      open={show}
      onClose={handleCloseAndResetError}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h4 className="fadeIn first title">Returning Bees - Ready to Buy</h4>

        <form onSubmit={submit} className="form-login">
        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', color:'#FF0000' }}>

          <Input
            label="Email"
            state={email}
            setState={setEmail}
            name={email}
          />

          <Input
            label="Password"
            state={password}
            setState={setPassword}
            name={password}
            type="password" 
          />

          {errorMessage ?
            <span style={{ marginBottom: '0.5em', display: 'flex', alignItems: 'center',  whiteSpace: 'pre-line' }}><WarningIcon /> {errorMessage}</span>
            : null
          }

            <div className="boxTerm">
              <Checkbox id="exampleCheck1" />
              Keep me logged in
            </div>

        </span>

          <div className="sign-in-button">
            {isLoading ?
              <CircularProgress style={{ margin: '1em 0 0 0' }} />
              :
              <SignInButton />
            }
          </div>

          {/* <div className="boxInput">
            <div className="boxTerm">Or Sign In with</div>
          </div> */}

          <div className="">
            {/* <GoogleLogin
              clientId="724026832892-8cd8tqqmadpshkh1dfbfnk42utvjv0ji.apps.googleusercontent.com"
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy={"single_host_origin"}
              icon={false}
              className="icon-google"
            >
              <svg
                width="51"
                height="51"
                viewBox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.5 0.5C11.6917 0.5 0.5 11.6937 0.5 25.5C0.5 39.3062 11.6917 50.5 25.5 50.5C39.3062 50.5 50.5 39.3062 50.5 25.5C50.5 11.6937 39.3062 0.5 25.5 0.5ZM25.7917 40.1208C17.7333 40.1208 11.2083 33.5792 11.2083 25.5C11.2083 17.4208 17.7333 10.8792 25.7917 10.8792C29.7292 10.8792 33.0208 12.3312 35.5458 14.6896L31.4333 18.8104V18.8021C29.9021 17.3396 27.9604 16.5896 25.7917 16.5896C20.9792 16.5896 17.0688 20.6646 17.0688 25.4917C17.0688 30.3146 20.9792 34.4021 25.7917 34.4021C30.1583 34.4021 33.1292 31.8979 33.7417 28.4604H25.7917V22.7583H39.5104C39.6937 23.7375 39.7917 24.7583 39.7917 25.8292C39.7917 34.1833 34.2146 40.1208 25.7917 40.1208Z"
                  fill="#F29B1B"
                />
              </svg>
            </GoogleLogin> */}
          </div>

          <div className="login-footer">
            <div className="boxTerm">
              <Link
                onClick={() => handleClose()}
                to="/forgot-password"
                className=" text-decoration-none tx-orange-hover"
              >
                Reset Password
              </Link>
              <span className=" text-decoration-none" style={{ margin: "0 20px 0" }}>|</span>

              <Link
                onClick={() => handleClose()}
                to="/signup"
                className=" text-decoration-none tx-orange-hover">
                Create an account
              </Link>
            </div>
          </div>

        </form>
      </Box>
    </Modal>
  );
}
